<template>
  <div>
    <mia-car-edit-shared-page-header />

    <mia-owns-car>
      <mia-car-vti-return-form class="mt-8" />
    </mia-owns-car>
  </div>
</template>

<script>
import SharedPageHeader from '@/components/cars/edit/SharedPageHeader.vue'
import CarVtiReturnForm from '@/components/cars/edit/forms/CarVtiReturnForm.vue'

export default {
  name: 'MiaCarEditProvisions',

  components: {
    'mia-car-edit-shared-page-header': SharedPageHeader,
    'mia-car-vti-return-form': CarVtiReturnForm
  },

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  }
}
</script>
